export const isEdge = function() {
    return window.navigator && window.navigator.msSaveOrOpenBlob;
};

export const isChrome = function(){
    return navigator.userAgent.indexOf('Chrome') > -1;
};


export const isSafari = function(){
    return navigator.userAgent.indexOf('Safari') > -1;
};



// WEBPACK FOOTER //
// ./src/services/browserDetector.js